import axios, { AxiosInstance } from 'axios'
import { MessageRequest, MessageResponse, HealthResponse, ConversationStats } from '../types/chat'

export class ApiClient {
  private client: AxiosInstance

  constructor(baseUrl: string) {
    this.client = axios.create({
      baseURL: baseUrl,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  async sendMessage(message: MessageRequest): Promise<MessageResponse> {
    const response = await this.client.post<MessageResponse>('/message', message)
    return response.data
  }

  async sendProactiveMessage(phoneNumber: string): Promise<MessageResponse> {
    const message: MessageRequest = {
      from: phoneNumber,
      body: 'INIT_PROACTIVE_CONTACT',
      type: 'text',
      isProactive: true
    }
    return this.sendMessage(message)
  }

  async healthCheck(): Promise<HealthResponse> {
    const response = await this.client.get<HealthResponse>('/health')
    return response.data
  }

  async resetContext(phoneNumber: string): Promise<void> {
    await this.client.post(`/reset-context/${encodeURIComponent(phoneNumber)}`)
  }

  async getConversationStats(phoneNumber: string): Promise<ConversationStats> {
    const response = await this.client.get<ConversationStats>(
      `/stats/${encodeURIComponent(phoneNumber)}`
    )
    return response.data
  }

  async loadConversation(phoneNumber: string): Promise<MessageResponse[]> {
    const response = await this.client.get<MessageResponse[]>(
      `/conversation/${encodeURIComponent(phoneNumber)}`
    )
    return response.data
  }

  async getCurrentClientTag(phoneNumber: string): Promise<{ tag: string | null, name: string | null }> {
    const response = await this.client.get(`/admin/tags/current/${encodeURIComponent(phoneNumber)}`)
    return response.data
  }

  async getAllClientsWithTags(): Promise<any> {
    const response = await this.client.get('/admin/tags/clients')
    return response.data
  }

  updateBaseUrl(baseUrl: string): void {
    this.client.defaults.baseURL = baseUrl
  }
}